// extracted by mini-css-extract-plugin
export default {"container":"cec26296"};